// extracted by mini-css-extract-plugin
module.exports = {"container":"e2ff468f85--container--MknCw","container--size-m":"e2ff468f85--container--size-m--X9dbp"};